<template>
  <div>
    <div class="KFatura lazer">
      <div class="KFaturaIc">
        <div class="KHeader text-center">
          <div class="clearfix"></div>
          <div class="KHeaderBilgi">
            <svg class="d-block" width="100%" height="18">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="18"
                    font-weight="bold">{{ f.AdSoyad }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="12">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12" font-weight="bold">
                ABONE NO: {{ f.AboneNo }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="10">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10" font-weight="bold">
                {{ Fatura.BinaAdi }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="10">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="10">No: {{ f.kNo }} /
                {{ f.m2 }} m2
              </text>
            </svg>
            <svg class="d-block" width="100%" height="12">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                {{ Fatura.aciklama }}
              </text>
            </svg>
            <svg class="d-block" width="100%" height="20">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12"
                    font-weight="bold">ISINMA GİDER PAYLAŞIM BELGESİ
              </text>
            </svg>

          </div>
          <div class="KHeaderTutar">
            <div class="pull-left" style="width: 50%;padding: 5px">
              <svg width="100%" height="15" class="d-block">
                <text x="0" y="10" font-size="10" text-anchor="start"
                      font-weight="bold">ÖDENECEK TUTAR
                </text>
              </svg>
              <svg width="100%" height="22" class="d-block">
                <text x="0" y="18" font-size="20" text-anchor="start"
                      font-weight="bold">{{ f.Odenecek }}TL
                </text>
              </svg>
            </div>
            <div class="pull-right" style="width: 50%;padding: 5px">
              <svg width="100%" height="15" class="d-block">
                <text x="100%" y="10" font-size="10" text-anchor="end"
                      font-weight="bold">SON ÖDEME TARİHİ
                </text>
              </svg>
              <svg width="100%" height="22" class="d-block">
                <text x="100%" y="18" font-size="18" text-anchor="end"
                >{{ Fatura.starih }}
                </text>
              </svg>
            </div>
            <div class="clearfix"></div>
          </div>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="2" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">GİDER DETAYLARI
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="Fatura.Tur==1">
              <td :rowspan="Fatura.MuafPay?4:3" width="70px">
                <svg width="100%" height="20">
                  <text x="0" y="10" font-size="10" font-weight="bold" text-anchor="start">ISINMA</text>
                  <text x="0" y="20" font-size="10" font-weight="bold" text-anchor="start">GİDERLERİ</text>
                </svg>
              </td>
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">TÜKETİM BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.tUcret }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.Tur==1">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">ORTAK ALAN BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.oAlan }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.MuafPay">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">MUAF MESKEN PAYI</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.MuafUcret }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.Tur==1">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">15°C MANİPÜLASYON</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.iFark }} kWh</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.SicakSu">
              <td rowspan="3" width="70px">
                <svg width="100%" height="20">
                  <text x="0" y="10" font-size="10" font-weight="bold" text-anchor="start">SICAK SU</text>
                  <text x="0" y="20" font-size="10" font-weight="bold" text-anchor="start">GİDERLERİ</text>
                </svg>
              </td>
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">TÜKETİM BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.sTuketim }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.SicakSu">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">ORTAK ALAN BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.SuOrtak }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.SicakSu">
              <td>
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">ŞEBEKE BEDELİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.sSebeke }} TL</text>
                </svg>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">OKUMA ÜCRETİ</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.Okuma }} TL</text>
                </svg>
              </td>
            </tr>
            <tr v-if="Fatura.eAciklama">
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" text-anchor="start">{{ Fatura.eAciklama }}</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.eTutar }} TL</text>
                </svg>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <svg class="pull-left" width="48%" height="10">
                  <text x="0" y="8" font-size="8" font-weight="bold" text-anchor="start">ALT TOPLAM</text>
                </svg>
                <svg class="pull-right" width="48%" height="10">
                  <text x="100%" y="8" font-size="8" font-weight="bold" text-anchor="end">{{ f.Odenecek }} TL</text>
                </svg>
              </td>
            </tr>
            </tbody>
          </table>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="5" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    SAYAÇ VE ENDEKS DETAYLARI
                  </text>
                </svg>
              </th>
            </tr>
            <tr>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    NO
                  </text>
                </svg>
              </th>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    {{ Fatura.PayOlcer ? 'ODA' : 'TÜR' }}
                  </text>
                </svg>
              </th>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    İLK
                  </text>
                </svg>
              </th>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">SON
                  </text>
                </svg>
              </th>
              <th>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">FARK
                  </text>
                </svg>
              </th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="s in f.Sayac">
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle">{{
                      s.SayacNo
                    }}
                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle">
                    {{ Fatura.PayOlcer ? s.OdaAdi : s.Tur }}

                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle">
                    {{ s.Ilk }}{{ s.Birim }}
                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle">
                    {{ s.Son }}{{ s.Birim }}
                  </text>
                </svg>
              </td>
              <td>
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-size="8" dominant-baseline="middle" text-anchor="middle">
                    {{ s.Fark }}{{ s.Birim }}
                  </text>
                </svg>
              </td>
            </tr>
            </tbody>
          </table>
          <table v-if="f.Uyari" class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="5" class="text-center">
                <svg width="100%" height="8">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    {{ f.Uyari }}
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
          </table>
          <table class="table table-xs table-bordered">
            <thead>
            <tr>
              <th colspan="3" class="text-center">
                <svg width="100%" height="10">
                  <text x="50%" y="50%" font-weight="bold" font-size="8" dominant-baseline="middle"
                        text-anchor="middle">
                    DÖNEM VE HESAPLAMA VERİLERİ
                  </text>
                </svg>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-right" width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    YAKIT FATURASI
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ Fatura.tutar }}TL
                  </text>
                </svg>
              </td>
              <td width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8"
                        text-anchor="start">
                    TOPLAM ALAN
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="8" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ AltToplam.KapaliAlan }} m²
                  </text>
                </svg>
              </td>

              <td class="text-right" width="50" v-if="Fatura.Tur==1">

                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    ORTAK ALAN HESABI
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    %{{ Fatura.oAlan }} - {{ AltToplam.oAlan }}TL
                  </text>
                </svg>
              </td>
              <td class="text-right" width="50" v-if="Fatura.Tur==2">

                <svg width="100%" height="8" class="d-block">
                  <text x="100%" y="8" font-size="8"
                        text-anchor="end">
                    ORTAK ALAN HESABI
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="100%" y="10" font-weight="bold" font-size="10"
                        text-anchor="end">
                    %{{ Fatura.oAlan }} - {{ AltToplam.SuOrtak }}TL
                  </text>
                </svg>
              </td>
            </tr>
            <tr v-if="AltToplam.sTuketim!='0,00'">
              <td width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8"
                        text-anchor="start">
                    ŞEBEKE BEDELİ
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ Fatura.SuBirim }}TL
                  </text>
                </svg>
              </td>
              <td width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8"
                        text-anchor="start">
                    SU ISINMA
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ AltToplam.sTuketim }}TL
                  </text>
                </svg>
              </td>
              <td class="text-right" width="50">

                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8"
                        text-anchor="start">
                    SICAK SU BİRİM
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="10" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ AltToplam.SuBirim }}TL
                  </text>
                </svg>
              </td>
            </tr>
            <tr>
              <td width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8"
                        text-anchor="start">
                    ISINMA TÜKETİM
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="8" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ AltToplam.tUcret }}TL
                  </text>
                </svg>
              </td>
              <td class="text-right" width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    HESAPLANAN ENERJİ
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="8" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ AltToplam.Hesap }}kWh
                  </text>
                </svg>
              </td>
              <td class="text-right" width="50">
                <svg width="100%" height="8" class="d-block">
                  <text x="0%" y="8" font-size="8" font-weight="bold"
                        text-anchor="start">
                    ENERJİ BİRİM
                  </text>
                </svg>
                <svg width="100%" height="12">
                  <text x="0%" y="8" font-weight="bold" font-size="10"
                        text-anchor="start">
                    {{ f.kWhBirim }}TL
                  </text>
                </svg>
              </td>
            </tr>


            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['f', 'Fatura', 'AltToplam']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Abone/AboneLazerDokumu.vue